
import { Component } from "vue-property-decorator"
import NichtGueltig from "../custom/NichtGueltig.vue"
import KundendatenReservierungLogic from "@/logic/bestellung_neu/kundendaten_reservierung_logic"
import { mixins } from "vue-class-component"
import Calculator from "../mixins/Calculator.vue"
import FilialeHeader from "../custom/FilialeHeader.vue"

@Component({ components: { NichtGueltig, FilialeHeader } })
export default class KundendatenReservierung extends mixins(Calculator) {
  $refs: {
    form: HTMLFormElement
  }

  logic: KundendatenReservierungLogic = null

  mounted() {
    this.logic = new KundendatenReservierungLogic()
    this.logic.init()
  }

  weiter() {
    var valid = this.$refs.form.validate()
    if (!valid) return

    this.logic.weiter()
  }

  produkteVorbestellen() {
    this.logic.produkteVorbestellen()
  }
}
